import emailjs from '@emailjs/browser'

type SendContactArgs = {
  name: string
  email: string
  message: string
}

export async function sendContact({ name, email, message }: SendContactArgs) {
  const serviceId = import.meta.env.VITE_EMAILJS_SERVICE_ID as string
  const templateId = import.meta.env.VITE_EMAILJS_TEMPLATE_ID as string
  const publicKey = import.meta.env.VITE_EMAILJS_PUBLIC_KEY as string
  if (!serviceId || !templateId || !publicKey) {
    throw new Error('EmailJS env variables are missing.')
  }
  return emailjs.send(
    serviceId,
    templateId,
    // Note: `reply_to` is mainly used to set the email "Reply-To" header.
    // If you also want to display the email inside the message body,
    // you must include it as a regular template variable (e.g. `from_email`)
    // and reference it in the EmailJS template content.
    { from_name: name, from_email: email, to_email: email, message },
    { publicKey }
  )
}


